import e from "./_Symbol.js";
import i from "./isArguments.js";
import o from "./isArray.js";
var t = e, m = i, s = o, a = t ? t.isConcatSpreadable : void 0;
function n(r) {
  return s(r) || m(r) || !!(a && r && r[a]);
}
var p = n;
export {
  p as default
};
//# sourceMappingURL=_isFlattenable.js.map
